import React from 'react';
import {
  Button,
  Typography
} from '@mui/material';



function GreenButton(props) {
  const { text, type, startIcon, endIcon, onClick, fontSize, buttonHeight, buttonWidth, margin, bgColor, disableDropShadow, children, style, disabled } = props

  // Set default styles
  let bgColorFinal = 'rgb(107, 164, 125)';

  // Style overrides
  if (bgColor != undefined){
    bgColorFinal = bgColor;
  }

  let greenButtonStyle = {
    backgroundColor: bgColorFinal,
    color: 'white',
    textTransform: 'none',
    fontWeight: 'bold',
    transition:'0.4s',
    ...style
  };

  return (
    <Button
      disabled={disabled}
      type={type}
      variant="contained"
      style={greenButtonStyle}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      disableElevation={disableDropShadow}
      sx={{
        height: buttonHeight,
        width: buttonWidth,
        margin: margin,
        '&.Mui-disabled':{
          opacity:'0.2'
        }
      }}
    >
  
      <Typography fontSize={fontSize}>{text}</Typography>
      
      {children}
    </Button>
  );
}

export default GreenButton;